import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const Footer = ({ auth: { user } }) => {
	const isAdmin = user && user.ruolo === 'admin';

	return (
		<div class="footer wf-section">
    		<div class="container">
      			<div class="w100">
        			<p class="center footer footer-mobile">per assistenza: <a href="mailto:segreteria@amministrazioni2t.com?subject=Assistenza%20Portale%20Condomini" class="link white">segreteria@amministrazioni2t.com</a>{isAdmin ? <React.Fragment>  -  <a href="/changelog" class="link white">changelog</a></React.Fragment> : null} -  22am digital studio</p>
      			</div>
    		</div>
  		</div>
	)
}

Footer.propTypes = {
	auth: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
	auth: state.auth
});

export default connect(mapStateToProps)(Footer);
